import { Component, HostListener, OnInit } from '@angular/core';
import { ApprovalNotificationService } from './approval-notification.service';
import { forkJoin, interval, Subscription } from 'rxjs';
import { DataService } from 'src/app/helpers/data.service';
import { iApprovalsList } from 'src/app/helpers/Interfaces/approvals-list';
import { ApprovalsList } from 'src/app/helpers/approvals-list';

@Component({
  selector: 'app-approval-notification',
  templateUrl: './approval-notification.component.html',
  styleUrls: ['./approval-notification.component.scss']
})
export class ApprovalNotificationComponent implements OnInit {

  isOpen = false;
  loading = true;
  approvals: iApprovalsList[] = ApprovalsList;
  private pollingSub!: Subscription;

  constructor(
    private _approvalServ: ApprovalNotificationService,
    private _dataServ: DataService,
  ) { }

  ngOnInit(): void {
    this.loadApprovals();
    this.startPolling();
  }

  ngOnDestroy(): void {
    this.pollingSub?.unsubscribe();
  }

  private loadApprovals(): void {
    const employeeId = this._dataServ.employeeValue.id;
    const userId = this._dataServ.employeeValue.userId;

    forkJoin({
      leave: this._approvalServ.GetLeaveApprovals(employeeId),
      appraisal: this._approvalServ.GetAppraisalApprovals(),
      easyForm: this._approvalServ.GetEasyFormApprovals(),
      jobRequest: this._approvalServ.GetJobRequestApprovals(),
      jobRequisition: this._approvalServ.GetJobRequisitionApprovals(),
      assetPro: this._approvalServ.GetAssetProApprovals(userId),
      easyFee: this._approvalServ.GetEasyFeeApprovals(employeeId),
    }).subscribe((res) => {
      this.approvals.forEach(item => {
        if (item.key === 'purchaseRequisition') {
          item.count = res.assetPro.prCount;
        }
        else if (item.key === 'procurement') {
          item.count = res.assetPro.procurementCount;
        }
        else if (item.key === 'purchaseOrder') {
          item.count = res.assetPro.poCount;
        }
        else if (
          item.key === 'backupRequests' ||
          item.key === 'transferRequests' ||
          item.key === 'leaveRequests'
        ) {

          const easyFeeMap: Record<string, string> = {
            backupRequests: 'Backup Requests',
            transferRequests: 'Transfer Requests',
            leaveRequests: 'Leave Requests'
          };

          const matched = res.easyFee.find(
            x => x.Name === easyFeeMap[item.key]
          );

          item.count = matched?.count || 0;
        }
        else {
          item.count = res[item.key as keyof typeof res] || 0;
        }
      });

      this.loading = false;
    });
  }

  private startPolling(): void {
    this.pollingSub = interval(15 * 60 * 1000)
      .subscribe(() => {
        this.loadApprovals();
      });
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  navigate(item: any) {
    window.open(item.route, '_blank');
    this.isOpen = false;
  }

  get totalCount(): number {
    return this.approvals.reduce((sum, item) => sum + (item.count || 0), 0);
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.approval-container')) {
      this.isOpen = false;
    }
  }
}
